//import './App.css';
import Root from './routes/routes';
import './assets/css/style.css';
import { BrowserRouter } from "react-router-dom";
function App() {
  return (
    <div className="App">
        <BrowserRouter>
         <Root/>
        </BrowserRouter>
        
    </div>
  );
}

export default App;
